import { render, staticRenderFns } from "./HomeUsedCars.vue?vue&type=template&id=bbefa91c&scoped=true&"
var script = {}
import style0 from "./HomeUsedCars.vue?vue&type=style&index=0&id=bbefa91c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbefa91c",
  null
  
)

export default component.exports